import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Diagnostic from "@/pages/Diagnostic";
import Transition from "@/pages/Transition";
import PreResult from "@/pages/PreResult";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminDetail from "@/pages/AdminDetail";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/diagnostic" element={<Diagnostic />} />
          <Route path="/transition" element={<Transition />} />
          <Route path="/restitution" element={<PreResult />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/diagnostics/:id" element={<AdminDetail />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
